module.exports = __webpack_public_path__ + "static/media/muftiSY.b5d4e86a.jpg";